<template>
    <div>
        <h3 class="title is-5">Change password</h3>

        <backend-errors :data="change_password.error"/>

        <base-message v-if="change_password.succeed">
            Your password was successfully updated.
        </base-message>

        <base-input
            label="Old password"
            v-model="form.old_password"
            name="old_password"
            type="password"
            icon="fas fa-lock"
            validate="required"
            placeholder="Old password"/>

        <base-input
            label="New password"
            v-model="form.new_password"
            name="new_password"
            type="password"
            icon="fas fa-lock"
            validate="required|min:8"
            placeholder="New password"/><br/>

        <base-button
            @click="send"
            :loading="change_password.loading"
            class="is-primary"
            icon="fas fa-check"
            text="Change"/>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import BackendErrors from '../base/BackendErrors.vue';

export default {
    name: 'UserChangePassword',
    components: { BackendErrors },
    data() {
        return {
            form: { old_password: null, new_password: null },
        };
    },
    computed: mapState('user', ['change_password']),
    destroyed() {
        this.$store.commit('user/clean_change_password');
    },
    methods: {
        send() {
            this.$validator.validate().then((result) => {
                if (!result) return;
                this.$store.dispatch('user/change_password', this.form);
            });
        },
    },
};
</script>
